<p-dialog
  [(visible)]="displayDialog"
  [modal]="true"
  [style]="{ width: '35vw' }"
  (onHide)="onClosePopup()"
>
  <ng-template pTemplate="header">
    <div class="title">
      {{ title }}
    </div>
  </ng-template>

  <div class="formgrid grid">
    <div class="dialog-content m-auto">
      @if (isSuccess) {
      <div class="row">
        <div class="row status-container">
          <div class="status-content">
            <span class="circle-progress circle">100%</span>

            <div class="successfully-message">
              <span class="status-icon success-icon">✓</span>
              <span translate>message.file_imported_succesfully</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col button-center">
            <button
              pButton
              class="p-button-primary button-confirm"
              type="button"
              (click)="onClosePopup()"
              translate>
              buttons.close
            </button>
          </div>
        </div>
      </div>
      }

      @if (!isSuccess) {
      <div class="row">
        <div class="row status-container text-center">
          <div>
            <div class="error-message">
              <span class="status-icon error-icon">!</span>
              Could not complete the operation.
            </div>

            <div translate>
              error.file.download_log
            </div>
          </div>
        </div>

        <div class="row">
          <div class="d-flex justify-content-center pb-30">
            <img
              src="assets/img/log-file.png"
              class="log-file-icon mr-3"
              alt="Log file"/>

            <app-button
              id="download-file"
              buttonClass="btn-primary"
              buttonType="button"
              (click)="onDownload()">
              <span>{{ 'buttons.download_log' | translate }}</span>
            </app-button>

            <app-button
              id="canceldownload"
              buttonClass="btn-secondary mr-0"
              buttonType="button"
              (clickEvent)="onClosePopup()">
              <span translate>buttons.close</span>
            </app-button>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</p-dialog>